<div class="login-container" [formGroup]="login">
  <mat-form-field>
    <input
      matInput
      formControlName="email"
      placeholder="Enter email"
      [required]="true"
    />
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="password"
      placeholder="Enter password"
      [required]="true"
      type="password"
    />
  </mat-form-field>
  <button mat-button (click)="loginFire()">LOGIN</button>
</div>
